import React, { useState } from "react";
import { usePost, useGet } from 'seed/api';
import { Modal } from "seed/helpers";
import { FORM_STATUS } from './Form.lib';
import l from "components/util/l";
import WSManager from "components/util/ws";
import View from './FormView.view'

const ActionForm = ({ 
  flow
}) => {

  const userId = sessionStorage.getItem("id");
  const executionSessionId = sessionStorage.getItem("execution_session_id");
  const actionFormRoom = `SHOW_ACTION_FORM_${userId}_${executionSessionId}`;
  const [isShown, setIsShown] = useState(false);
  const [formData, setFormData] = useState(null);
  const [formStatus, setFormStatus] = useState(FORM_STATUS.LOADING);
  const [validationMessage, setValidationMessage] = useState(null);

  const title = formData?.title;
  const token = formData?.token;
  const schema = formData?.schema;
  const nodeId = formData?.node_id;
  const executionId = formData?.execution_id;
  const styleScript = formData?.styleScript;
  const validationScript = formData?.validationScript;

  const [callSendForm] = usePost("/apps/forms/send_form", {
    onCompleted: () => {
      setFormStatus(FORM_STATUS.COMPLETED)
      setIsShown(false);
    },
    onError: () => setFormStatus(FORM_STATUS.ERROR)
  });

  const reqUser = useGet("/auth/user");

  const onMessageReceived = (message) => {
    setFormData(message?.data);
    setFormStatus(FORM_STATUS.ACTIVE);
    setIsShown(true);
  }

  const onFormSubmit = (data) => {
    
    setFormStatus(FORM_STATUS.LOADING)

    const validatedData = validationScript ? eval(validationScript)(data) : { validated: true };  // eslint-disable-line no-eval 
    if (!validatedData.validated) {
      setFormStatus(FORM_STATUS.ACTIVE)
      return setValidationMessage(validatedData.message ? 
        validatedData.message : 
        l("Error de validación, revisa los datos enviados%VA023"));
    }

    callSendForm({
      response: data,
      sender_id: userId,
      node_id: nodeId,
      execution_id: executionId,
      session_id: executionSessionId,
      token: token,
    });

  }

  return <>
    {isShown &&
      <Modal 
        width={600}
        height={800}
        onClose={() => setIsShown(false)}
        flow={flow}
        nodeId={nodeId}
        formTitle={title}
        schema={schema}
        styleScript={styleScript}
        formStatus={formStatus}
        validationMessage={validationMessage}
        reqUser={reqUser}
        onFormSubmit={onFormSubmit}
        fullscreenStyles={false}
        component={View}
      />
    }
    <WSManager
      initialRoom={actionFormRoom}
      autoSuscribe={true}
      onMessageReceived={onMessageReceived}
    />
  </>;

}

export default ActionForm;